/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedCouponResponse } from '../../models/paginated-coupon-response';

export interface CouponsGet$Params {
  'Active-Tenant-Identifier': string;
  page?: number;

/**
 * Number of results per call. Default 25.
 */
  size?: number;
  sortField?: Array<string>;
  sortDirection?: Array<string>;
  filter?: Array<string>;
  query?: string;
}

export function couponsGet(http: HttpClient, rootUrl: string, params: CouponsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedCouponResponse>> {
  const rb = new RequestBuilder(rootUrl, couponsGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sortField', params.sortField, {"style":"form","explode":true});
    rb.query('sortDirection', params.sortDirection, {"style":"form","explode":true});
    rb.query('filter', params.filter, {"style":"form","explode":true});
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedCouponResponse>;
    })
  );
}

couponsGet.PATH = '/coupons';
